// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file pull_requests/v1/deployments.proto (package github.pull_requests.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pull_requests/v1/deployments.proto.
 */
export const file_pull_requests_v1_deployments: GenFile = /*@__PURE__*/
  fileDesc("CiJwdWxsX3JlcXVlc3RzL3YxL2RlcGxveW1lbnRzLnByb3RvEhdnaXRodWIucHVsbF9yZXF1ZXN0cy52MSJmChNEZXBsb3ltZW50c1Jlc3BvbnNlEjgKC2RlcGxveW1lbnRzGAEgAygLMiMuZ2l0aHViLnB1bGxfcmVxdWVzdHMudjEuRGVwbG95bWVudBIVCg1hbGl2ZV9jaGFubmVsGAIgASgJIjUKEERlcGxveW1lbnRBdXRob3ISDQoFbG9naW4YASABKAkSEgoKYXZhdGFyX3VybBgCIAEoCSKEAgoKRGVwbG95bWVudBI+CgZzdGF0dXMYASABKA4yLi5naXRodWIucHVsbF9yZXF1ZXN0cy52MS5EZXBsb3ltZW50U3RhdHVzU3RhdGUSDAoEbmFtZRgCIAEoCRIWCg5kZXBsb3ltZW50X3VybBgDIAEoCRIUCgx3b3JrZmxvd191cmwYBCABKAkSOQoGYXV0aG9yGAUgASgLMikuZ2l0aHViLnB1bGxfcmVxdWVzdHMudjEuRGVwbG95bWVudEF1dGhvchIRCgl0aW1lc3RhbXAYBiABKAkSEgoKY29tbWl0X29pZBgHIAEoCRIYChBjb21taXRfc2hvcnRfc2hhGAggASgJKtwDChVEZXBsb3ltZW50U3RhdHVzU3RhdGUSJwojREVQTE9ZTUVOVF9TVEFUVVNfU1RBVEVfVU5TUEVDSUZJRUQQABIjCh9ERVBMT1lNRU5UX1NUQVRVU19TVEFURV9QRU5ESU5HEAESIwofREVQTE9ZTUVOVF9TVEFUVVNfU1RBVEVfU1VDQ0VTUxACEiMKH0RFUExPWU1FTlRfU1RBVFVTX1NUQVRFX0ZBSUxVUkUQAxIkCiBERVBMT1lNRU5UX1NUQVRVU19TVEFURV9JTkFDVElWRRAEEiEKHURFUExPWU1FTlRfU1RBVFVTX1NUQVRFX0VSUk9SEAUSIgoeREVQTE9ZTUVOVF9TVEFUVVNfU1RBVEVfUVVFVUVEEAYSJwojREVQTE9ZTUVOVF9TVEFUVVNfU1RBVEVfSU5fUFJPR1JFU1MQBxIjCh9ERVBMT1lNRU5UX1NUQVRVU19TVEFURV9XQUlUSU5HEAgSIgoeREVQTE9ZTUVOVF9TVEFUVVNfU1RBVEVfQUNUSVZFEAkSJQohREVQTE9ZTUVOVF9TVEFUVVNfU1RBVEVfQUJBTkRPTkVEEAoSJQohREVQTE9ZTUVOVF9TVEFUVVNfU1RBVEVfREVTVFJPWUVEEAtiBnByb3RvMw");

/**
 * Response payload for
 * GET /:owner/:repo/pull/:number/page_data/deployments
 *
 * Defined by PullRequests::PageData::SharedController#deployments.
 *
 * @generated from message github.pull_requests.v1.DeploymentsResponse
 */
export type DeploymentsResponse = Message<"github.pull_requests.v1.DeploymentsResponse"> & {
  /**
   * @generated from field: repeated github.pull_requests.v1.Deployment deployments = 1;
   */
  deployments: Deployment[];

  /**
   * Live update channel the consumer subscribes to so the deployments child
   * route refreshes when a pull request's deployments change.
   *
   * @generated from field: string alive_channel = 2;
   */
  aliveChannel: string;
};

/**
 * Describes the message github.pull_requests.v1.DeploymentsResponse.
 * Use `create(DeploymentsResponseSchema)` to create a new message.
 */
export const DeploymentsResponseSchema: GenMessage<DeploymentsResponse> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_deployments, 0);

/**
 * @generated from message github.pull_requests.v1.DeploymentAuthor
 */
export type DeploymentAuthor = Message<"github.pull_requests.v1.DeploymentAuthor"> & {
  /**
   * @generated from field: string login = 1;
   */
  login: string;

  /**
   * @generated from field: string avatar_url = 2;
   */
  avatarUrl: string;
};

/**
 * Describes the message github.pull_requests.v1.DeploymentAuthor.
 * Use `create(DeploymentAuthorSchema)` to create a new message.
 */
export const DeploymentAuthorSchema: GenMessage<DeploymentAuthor> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_deployments, 1);

/**
 * @generated from message github.pull_requests.v1.Deployment
 */
export type Deployment = Message<"github.pull_requests.v1.Deployment"> & {
  /**
   * @generated from field: github.pull_requests.v1.DeploymentStatusState status = 1;
   */
  status: DeploymentStatusState;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string deployment_url = 3;
   */
  deploymentUrl: string;

  /**
   * @generated from field: string workflow_url = 4;
   */
  workflowUrl: string;

  /**
   * @generated from field: github.pull_requests.v1.DeploymentAuthor author = 5;
   */
  author?: DeploymentAuthor;

  /**
   * @generated from field: string timestamp = 6;
   */
  timestamp: string;

  /**
   * @generated from field: string commit_oid = 7;
   */
  commitOid: string;

  /**
   * @generated from field: string commit_short_sha = 8;
   */
  commitShortSha: string;
};

/**
 * Describes the message github.pull_requests.v1.Deployment.
 * Use `create(DeploymentSchema)` to create a new message.
 */
export const DeploymentSchema: GenMessage<Deployment> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_deployments, 2);

/**
 * The current state of a deployment, derived from Deployment#state. This
 * covers the DeploymentStatusState values plus the synthetic "active",
 * "abandoned", and "destroyed" states the model computes from the latest
 * status, the deployment's settings, and the time.
 *
 * @generated from enum github.pull_requests.v1.DeploymentStatusState
 */
export enum DeploymentStatusState {
  /**
   * @generated from enum value: DEPLOYMENT_STATUS_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEPLOYMENT_STATUS_STATE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: DEPLOYMENT_STATUS_STATE_SUCCESS = 2;
   */
  SUCCESS = 2,

  /**
   * @generated from enum value: DEPLOYMENT_STATUS_STATE_FAILURE = 3;
   */
  FAILURE = 3,

  /**
   * @generated from enum value: DEPLOYMENT_STATUS_STATE_INACTIVE = 4;
   */
  INACTIVE = 4,

  /**
   * @generated from enum value: DEPLOYMENT_STATUS_STATE_ERROR = 5;
   */
  ERROR = 5,

  /**
   * @generated from enum value: DEPLOYMENT_STATUS_STATE_QUEUED = 6;
   */
  QUEUED = 6,

  /**
   * @generated from enum value: DEPLOYMENT_STATUS_STATE_IN_PROGRESS = 7;
   */
  IN_PROGRESS = 7,

  /**
   * @generated from enum value: DEPLOYMENT_STATUS_STATE_WAITING = 8;
   */
  WAITING = 8,

  /**
   * @generated from enum value: DEPLOYMENT_STATUS_STATE_ACTIVE = 9;
   */
  ACTIVE = 9,

  /**
   * @generated from enum value: DEPLOYMENT_STATUS_STATE_ABANDONED = 10;
   */
  ABANDONED = 10,

  /**
   * @generated from enum value: DEPLOYMENT_STATUS_STATE_DESTROYED = 11;
   */
  DESTROYED = 11,
}

/**
 * Describes the enum github.pull_requests.v1.DeploymentStatusState.
 */
export const DeploymentStatusStateSchema: GenEnum<DeploymentStatusState> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_deployments, 0);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(DeploymentsResponseSchema, "767423708f99")
registerSchemaHash(DeploymentAuthorSchema, "abb7893717b3")
registerSchemaHash(DeploymentSchema, "8e8f0037ccb9")
